
import React from 'react';
import { CheckCircle, Users, Calendar, TrendingUp, Shield, BarChart4 } from 'lucide-react';

const CtoServiceFeatures = () => {
  const features = [
    {
      icon: <Users className="h-10 w-10 text-blue-600" />,
      title: "Budget-Boss",
      description: "Jahres- und Quartalsbudget planen, Forecasts checken, Einsparpotenziale rausholen."
    },
    {
      icon: <TrendingUp className="h-10 w-10 text-blue-600" />,
      title: "Roadmap-Bauleiter",
      description: "Digitale Initiativen priorisieren, Meilensteine setzen, Risiken managen."
    },
    {
      icon: <Shield className="h-10 w-10 text-blue-600" />,
      title: "Vendor-Torwart",
      description: "Angebote filtern, Verträge verhandeln, SLA-Kontrollen fahren."
    },
    {
      icon: <BarChart4 className="h-10 w-10 text-blue-600" />,
      title: "KPI-Reporter",
      description: "Board-Decks mit Ist/Soll-Budget, ROI-Scores & Risk-Heatmap liefern."
    },
    {
      icon: <CheckCircle className="h-10 w-10 text-blue-600" />,
      title: "Change-Coach",
      description: "Storytelling für Stakeholder, Schulungen & Change-Management."
    },
    {
      icon: <Calendar className="h-10 w-10 text-blue-600" />,
      title: "Remote & Unabhängig",
      description: "Alles remote, unabhängig und immer in deinem Interesse."
    }
  ];

  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Was wir für dich tun</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            So entlasten wir dich bei der IT-Führung – professionell und kosteneffizient
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
          {features.map((feature, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <div className="mb-4">
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CtoServiceFeatures;
